import React, { Component }     from 'react';
import PropTypes                from 'prop-types';
import { connect }              from 'react-redux';
import Modal                    from '../Modal';
import { updateEmail }          from '../../services/email';
import { RESULT_CODE }          from '../../const/result_code_const';
import EmailUpdateConfirmation  from './EmailUpdateConfirmation';
import * as modal               from '../../reducers/modalReducer';
import {
  INTERNAL_ERROR,
  RETRIEVE_TOKEN_NOT_FOUND,
}                               from '../../const/email_const';

class EmailUpdateConfirmationModal extends Component {
  state = {
    isLoading: false,
    isEmailUpdated: false,
    errorMessage: '',
  }

  componentDidMount() {
    if (!this.getRetrieveToken()) {
      this.setState({
        errorMessage: RETRIEVE_TOKEN_NOT_FOUND,
      });
      return;
    }

    this.setProgress(true);

    updateEmail(this.getRetrieveToken()).then((response) => {
      const {
        resultCode,
        resultReason,
      } = response.data;

      if (resultCode === RESULT_CODE.SUCCESS) {
        this.setState({
          isEmailUpdated: true,
        });
      } else {
        console.error(`Update Email fail: ${JSON.stringify(response)}`);

        this.setState({
          errorMessage: resultReason,
        });
      }
    }).catch((e) => {
      console.error(e);

      this.setState({
        errorMessage: INTERNAL_ERROR,
      });
    }).finally(() => {
      this.setProgress(false);
    });
  }

  getRetrieveToken = () => this.props.retrieveToken;

  setProgress = (isLoading) => {
    this.setState({
      isLoading,
    });
  }

  render() {
    const {
      isLoading,
      isEmailUpdated,
      errorMessage,
    } = this.state;

    const {
      hideModal,
    } = this.props;

    return (
      <Modal
        isOpened
        paddingTop="65px"
        overlayTop={0}
        closeOnOverlayClick
        closeOnOutsideClick
        onClose={() => hideModal()}
      >
        <EmailUpdateConfirmation
          isLoading={isLoading}
          isEmailUpdated={isEmailUpdated}
          errorMessage={errorMessage}
          onCloseRequest={hideModal}
        />
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  router: state.router,
});

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(modal.hideModal()),
});

EmailUpdateConfirmationModal.propTypes = {
  retrieveToken: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailUpdateConfirmationModal);



// WEBPACK FOOTER //
// ./src/components/EmailUpdateConfirmationModal/EmailUpdateConfirmationModal.jsx